export enum ErrorCodes {
  EMPTY_FIELD = 'empty_field',
  CARE_TEAM_NOT_FOUND = 'care_team_not_found',
  PATIENT_NOT_FOUND = 'patient_not_found',
  PRACTITIONER_IS_NOT_CARE_TEAM_MEMBER = 'practitioner_is_not_care_team_member',
  PATIENT_IS_NOT_CARE_TEAM_MEMBER = 'patient_is_not_care_team_member',
  PATIENT_GROUP_NOT_FOUND = 'patient_group_not_found',
  PLAN_DEFINITION_NOT_FOUND = 'plan_definition_not_found',
  PLAN_DEFINITION_NOT_ACTIVE = 'plan_definition_not_active',
  PLAN_DEFINITION_HAS_NO_CARE_TEAM_CONFIGURATION = 'plan_definition_has_no_care_team_configuration',
  PRACTITIONER_HAS_NO_ACCESS_TO_PATIENT = 'practitioner_has_no_access_to_patient',
  PLAN_DEFINITION_ALREADY_ASSIGNED_TO_PATIENT = 'plan_definition_already_assigned_to_patient',
  CIRCULAR_HEALTH_METRIC_DEFINITION_SUBSCRIPTION_DETECTED = 'circular_health_metric_definition_subscription_detected',
  GLOBAL_HEALTH_METRIC_DEFINITION_CAN_NOT_SUBSCRIBE_TO_LOCAL_HEALTH_METRIC_DEFINITION = 'global_health_metric_definition_can_not_subscribe_to_local_health_metric_definition',
  HEALTH_METRIC_COMPONENT_DOES_NOT_HAVE_VALUE_FORMULA = 'health_metric_component_does_not_have_value_formula',
  HEALTH_METRIC_COMPONENT_DOES_NOT_SUPPORT_SUBSCRIPTIONS = 'health_metric_component_does_not_support_subscriptions',
  HEALTH_METRIC_COMPONENT_NOT_FOUND = 'health_metric_component_not_found',
  METRIC_DEFINITION_NOT_FOUND = 'metric_definition_not_found'
}

export const errorMessages = {
  [ErrorCodes.EMPTY_FIELD]: 'The field {{field}} is empty.',
  [ErrorCodes.CARE_TEAM_NOT_FOUND]:
    'Care team with id {{care_team_id}} was not found.',
  [ErrorCodes.PATIENT_NOT_FOUND]:
    'Patient with id {{patient_id}} was not found.',
  [ErrorCodes.PRACTITIONER_IS_NOT_CARE_TEAM_MEMBER]:
    'Practitioner with id {{practitioner_id}} is not a member of care team with id {{care_team_id}}.',
  [ErrorCodes.PATIENT_IS_NOT_CARE_TEAM_MEMBER]:
    'Patient with id {{patient_id}} is not a member of care team with id {{care_team_id}}.',
  [ErrorCodes.PATIENT_GROUP_NOT_FOUND]:
    'Patient group with id {{patient_group_id}} was not found.',
  [ErrorCodes.PLAN_DEFINITION_NOT_FOUND]:
    'Plan definition with id {{plan_definition_id}} was not found.',
  [ErrorCodes.PLAN_DEFINITION_NOT_ACTIVE]:
    'Plan definition with id {{plan_definition_id}} is not active.',
  [ErrorCodes.PLAN_DEFINITION_HAS_NO_CARE_TEAM_CONFIGURATION]:
    'Plan definition with id {{plan_definition_id}} has no care team configuration for care team with id {{care_team_id}}.',
  [ErrorCodes.PRACTITIONER_HAS_NO_ACCESS_TO_PATIENT]:
    'Practitioner with id {{practitioner_id}} has no access to patient with id {{patient_id}}.',
  [ErrorCodes.PLAN_DEFINITION_ALREADY_ASSIGNED_TO_PATIENT]:
    'Plan definition with id {{plan_definition_id}} is already assigned to patient with id {{patient_id}}.',
  [ErrorCodes.CIRCULAR_HEALTH_METRIC_DEFINITION_SUBSCRIPTION_DETECTED]: 'Circular health metric subscriptions detected.',
  [ErrorCodes.GLOBAL_HEALTH_METRIC_DEFINITION_CAN_NOT_SUBSCRIBE_TO_LOCAL_HEALTH_METRIC_DEFINITION]: 'Global health metric definition with id {{target_health_metric_definiton_id}} can not subscribe to local health metric definition with id {{source_health_metric_definiton_id}}.',
  [ErrorCodes.HEALTH_METRIC_COMPONENT_DOES_NOT_HAVE_VALUE_FORMULA]: 'Health metric subscription formula is empty.',
  [ErrorCodes.HEALTH_METRIC_COMPONENT_DOES_NOT_SUPPORT_SUBSCRIPTIONS]: 'Health metric definitoin with id {{health_metric_definiton_id}} does not support subscriptions.',
  [ErrorCodes.HEALTH_METRIC_COMPONENT_NOT_FOUND]: 'Health metric definition with id {{health_metric_definiton_id}} does not have component with id {{component_id}}.',
  [ErrorCodes.METRIC_DEFINITION_NOT_FOUND]: 'Health metric definition with id {{metric_definiton_id}} was not found.'
};

export default function getErrorMessage({
  code,
  params,
  getTranslation
}: {
  code: ErrorCodes;
  params: any;
  getTranslation?: (text: string, parameters?: { [key: string]: string }) => string
}) {
  let message = errorMessages[code];
  if (!message) {
    return 'Unknown error code';
  }

  if (getTranslation) {
    return getTranslation(message, params)
  }

  Object.keys(params).forEach((key) => {
    message = message.replace(`{{${key}}}`, params[key]);
  });
  return message;
}

export function getMessageFromError(
  error?: {
    message?: string;
    code?: ErrorCodes;
    params?: { [key: string]: string }
  },
  getTranslation?: (text: string, parameters?: { [key: string]: string }) => string,
) {
  if (error && error.code && errorMessages[error.code]) {
    return getErrorMessage({ code: error.code, params: error.params, getTranslation: getTranslation })
  }
  else if (error && error.message) {
    return error.message
  }
  else {
    return "An error occurred"
  }
}